<template>
  <a-breadcrumb>
    <a-breadcrumb-item>
      <a
        href="javascript:;"
        @click="back"
      >{{ $t('message["282"]') }} </a>
    </a-breadcrumb-item>
    <a-breadcrumb-item>{{ $t('message["1439"]') }}</a-breadcrumb-item>
  <!-- <span class="second-bread">
    <a
      href="javascript:;"
      @click="back"
    >{{ $t('message["282"]') }} </a>
    <i class="el-breadcrumb__separator el-icon-arrow-right" />
    <strong>{{ $t('message["1439"]') }}</strong>
  </span> -->
  </a-breadcrumb>
</template>
<script>
export default {
  props: {
    secondBread: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  computed: {
  },
  methods: {
    back () {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
.second-bread {
  font-size: 12px;

  em {
    color: #ccc;
    margin: 0 8px;
  }

  strong {
    font-weight: normal;
    color: #b3b3b3;
  }
}

</style>
